/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { Group_query$ref } from "./Group_query.graphql";
export type route_Group_QueryVariables = {
    readonly uuid: string;
};
export type route_Group_QueryResponse = {
    readonly " $fragmentRefs": Group_query$ref;
};
export type route_Group_Query = {
    readonly response: route_Group_QueryResponse;
    readonly variables: route_Group_QueryVariables;
};



/*
query route_Group_Query(
  $uuid: ID!
) {
  ...Group_query
}

fragment Group_query on Query {
  group(uuid: $uuid) {
    name
    logoImageLocation
    ...Breadcrumb_group
    id
  }
}

fragment Breadcrumb_group on Group {
  name
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "uuid",
    "type": "ID!",
    "defaultValue": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "route_Group_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "Group_query",
        "args": null
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "route_Group_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "group",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "uuid",
            "variableName": "uuid"
          }
        ],
        "concreteType": "Group",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "logoImageLocation",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "route_Group_Query",
    "id": null,
    "text": "query route_Group_Query(\n  $uuid: ID!\n) {\n  ...Group_query\n}\n\nfragment Group_query on Query {\n  group(uuid: $uuid) {\n    name\n    logoImageLocation\n    ...Breadcrumb_group\n    id\n  }\n}\n\nfragment Breadcrumb_group on Group {\n  name\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2aa6659595ff8406bd6e32023c4cdb4d';
export default node;
